/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const da_product_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("da", i.count, {});
	if (countPlural == "one") return `${i.count} produkt`;
	if (countPlural == "other") return `${i.count} produkter`;
	return "product_count";
};

const de_product_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("de", i.count, {});
	if (countPlural == "one") return `${i.count} produkt`;
	if (countPlural == "other") return `${i.count} produkte`;
	return "product_count";
};

const en_product_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("en", i.count, {});
	if (countPlural == "one") return `${i.count} product`;
	if (countPlural == "other") return `${i.count} products`;
	return "product_count";
};

const es_product_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("es", i.count, {});
	if (countPlural == "one") return `${i.count} producto`;
	if (countPlural == "other") return `${i.count} productos`;
	return "product_count";
};

const fr_product_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("fr", i.count, {});
	if (countPlural == "one") return `${i.count} produit`;
	if (countPlural == "other") return `${i.count} produits`;
	return "product_count";
};

const it_product_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("it", i.count, {});
	if (countPlural == "one") return `${i.count} prodotto`;
	if (countPlural == "other") return `${i.count} prodotti`;
	return "product_count";
};

const nl_product_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("nl", i.count, {});
	if (countPlural == "one") return `${i.count} product`;
	if (countPlural == "other") return `${i.count} producten`;
	return "product_count";
};

const pl_product_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("pl", i.count, {});
	if (countPlural == "one") return `${i.count} produkt`;
	if (countPlural == "other") return `${i.count} produkty`;
	return "product_count";
};

const pt_product_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("pt", i.count, {});
	if (countPlural == "one") return `${i.count} produto`;
	if (countPlural == "other") return `${i.count} produtos`;
	return "product_count";
};

const sv_product_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("sv", i.count, {});
	if (countPlural == "one") return `${i.count} produkt`;
	if (countPlural == "other") return `${i.count} produkter`;
	return "product_count";
};

/** @type {(inputs: { count: NonNullable<unknown> }) => string} */
const cs_product_count = en_product_count;

/** @type {(inputs: { count: NonNullable<unknown> }) => string} */
const hu_product_count = en_product_count;

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const product_count = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.product_count(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("product_count", locale)
	if (locale === "cs") return cs_product_count(inputs)
	if (locale === "da") return da_product_count(inputs)
	if (locale === "de") return de_product_count(inputs)
	if (locale === "en") return en_product_count(inputs)
	if (locale === "es") return es_product_count(inputs)
	if (locale === "fr") return fr_product_count(inputs)
	if (locale === "hu") return hu_product_count(inputs)
	if (locale === "it") return it_product_count(inputs)
	if (locale === "nl") return nl_product_count(inputs)
	if (locale === "pl") return pl_product_count(inputs)
	if (locale === "pt") return pt_product_count(inputs)
	return sv_product_count(inputs)
};